import '../../../style/coberturainventariosv.css'
import React, { useState, useMemo, useEffect } from 'react';
import apiServices from '../../../actions/services';
import * as XLSX from 'xlsx';

const CoberturaInventarioSV = () => {
  const [productos, setProductos] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [salaSeleccionada, setSalaSeleccionada] = useState('TODAS');
  const [cargando, setCargando] = useState(true);

  // Función para verificar si un producto tiene datos en alguna sala
  const tieneDatosEnAlgunaSala = (producto) => {
    const salas = ['TZ10', 'TPRR', 'TMIR', 'TXLA', 'TCSV', 'TSCR'];
    return salas.some(sala => {
      const datosSala = producto[sala];
      return datosSala && 
             (datosSala.inventariot > 0 || 
              datosSala.inventariof > 0 || 
              datosSala.venta > 0);
    });
  };

  // Función para transformar los datos obtenidos de la API
  const transformarDatos = (datosObtenidos) => {
    const productosTransformados = datosObtenidos.map(producto => {
      const productoTransformado = {
        codigo: producto.Codigo,
        nombre: producto.Nombre
      };

      // Transformar cada sala
      const salas = ['TZ10', 'TPRR', 'TMIR', 'TXLA', 'TCSV', 'TSCR'];
      salas.forEach(sala => {
        if (producto[sala] && producto[sala] !== '[]') {
          try {
            const datosSala = JSON.parse(producto[sala])[0];
            productoTransformado[sala] = {
              inventariot: parseFloat(datosSala.inventariot) || 0,
              inventariof: parseFloat(datosSala.inventariof) || 0,
              venta: parseFloat(datosSala.venta) || 0,
              consumodiario: parseFloat(datosSala.consumodiario) || 0,
              fecha: datosSala.fecha || ''
            };
          } catch (error) {
            console.error(`Error parsing ${sala} data:`, error);
            productoTransformado[sala] = { 
              inventariot: 0, 
              inventariof: 0, 
              venta: 0, 
              consumodiario: 0, 
              fecha: '' 
            };
          }
        } else {
          productoTransformado[sala] = { 
            inventariot: 0, 
            inventariof: 0, 
            venta: 0, 
            consumodiario: 0, 
            fecha: '' 
          };
        }
      });

      return productoTransformado;
    });

    // Filtrar productos que no tienen datos en ninguna sala
    return productosTransformados.filter(tieneDatosEnAlgunaSala);
  };
  

  // Función para recargar los datos
  const handleRecargarDatos = () => {
    // Vuelve a cargar los datos llamando al useEffect
    const cargarDatos = async () => {
      try {
        setCargando(true);
        const DAT = {};
        const resp = await apiServices.get("SalasInventarios_Obtener_Cobertura", DAT);
        
        if (resp && resp.datos_Generados) {
          const productosObtenidos = JSON.parse(resp.datos_Generados);
          const productosTransformados = transformarDatos(productosObtenidos);
          setProductos(productosTransformados);
          alert('Datos actualizados correctamente');
        }
      } catch (error) {
        console.error('Error al recargar datos:', error);
        alert('Error al recargar los datos');
      } finally {
        setCargando(false);
      }
    };

    cargarDatos();
  };


  // useEffect para cargar datos
  useEffect(() => {
    const cargarDatos = async () => {
      try {
        setCargando(true);
        const DAT = {};
        const resp = await apiServices.get("SalasInventarios_Obtener_Cobertura", DAT);
        
        if (resp && resp.datos_Generados) {
          const productosObtenidos = JSON.parse(resp.datos_Generados);
          const productosTransformados = transformarDatos(productosObtenidos);
          setProductos(productosTransformados);
        } else {
          // Datos de ejemplo como fallback con la nueva estructura
          const productosIniciales = [
            { 
              codigo: 'PTPR001', 
              nombre: 'Queso 1', 
              TZ10: { inventariot: 100, inventariof: 95, venta: 800, consumodiario: 26.67, fecha: '2024-01-15' }, 
              TPRR: { inventariot: 150, inventariof: 145, venta: 1200, consumodiario: 40, fecha: '2024-01-15' },
              TMIR: { inventariot: 0, inventariof: 0, venta: 0, consumodiario: 0, fecha: '' },
              TXLA: { inventariot: 0, inventariof: 0, venta: 0, consumodiario: 0, fecha: '' },
              TCSV: { inventariot: 0, inventariof: 0, venta: 0, consumodiario: 0, fecha: '' },
              TSCR: { inventariot: 0, inventariof: 0, venta: 0, consumodiario: 0, fecha: '' }
            },
            { 
              codigo: 'PTAJ00063', 
              nombre: 'Agua pura salvavidas 20 oz', 
              TZ10: { inventariot: 59, inventariof: 59, venta: 34, consumodiario: 1.13, fecha: '2024-01-15' },
              TMIR: { inventariot: 1350, inventariof: 1350, venta: 15, consumodiario: 0.5, fecha: '2024-01-15' },
              TXLA: { inventariot: 86, inventariof: 86, venta: 43, consumodiario: 1.43, fecha: '2024-01-15' },
              TPRR: { inventariot: 278, inventariof: 278, venta: 234, consumodiario: 7.8, fecha: '2024-01-15' },
              TSCR: { inventariot: 145, inventariof: 145, venta: 61, consumodiario: 2.03, fecha: '2024-01-15' },
              TCSV: { inventariot: 34, inventariof: 34, venta: 12, consumodiario: 0.4, fecha: '2024-01-15' }
            }
          ];
          // Filtrar los productos que no tienen datos
          const productosFiltrados = productosIniciales.filter(tieneDatosEnAlgunaSala);
          setProductos(productosFiltrados);
        }
      } catch (error) {
        console.error('Error al cargar datos:', error);
        // Datos de ejemplo en caso de error
        const productosIniciales = [
          { 
            codigo: 'PTPR001', 
            nombre: 'Queso 1', 
            TZ10: { inventariot: 100, inventariof: 95, venta: 800, consumodiario: 26.67, fecha: '2024-01-15' }, 
            TPRR: { inventariot: 150, inventariof: 145, venta: 1200, consumodiario: 40, fecha: '2024-01-15' },
            TMIR: { inventariot: 0, inventariof: 0, venta: 0, consumodiario: 0, fecha: '' },
            TXLA: { inventariot: 0, inventariof: 0, venta: 0, consumodiario: 0, fecha: '' },
            TCSV: { inventariot: 0, inventariof: 0, venta: 0, consumodiario: 0, fecha: '' },
            TSCR: { inventariot: 0, inventariof: 0, venta: 0, consumodiario: 0, fecha: '' }
          }
        ];
        const productosFiltrados = productosIniciales.filter(tieneDatosEnAlgunaSala);
        setProductos(productosFiltrados);
      } finally {
        setCargando(false);
      }
    };

    cargarDatos();
  }, []);

  // Función para calcular la cobertura en días (basada en inventariof)
  const calcularCobertura = (inventariof, venta) => {
    const ventaPromedioDiaria = venta / 30;
    if (ventaPromedioDiaria === 0) return 0;
    return (inventariof / ventaPromedioDiaria).toFixed(2);
  };

  // Función para calcular la variación entre inventariot e inventariof
  const calcularVariacion = (inventariot, inventariof) => {
    if (inventariot === 0) return '0.00%';
    const variacion = ((inventariof - inventariot) / inventariot) * 100;
    
    // Convertir a valor absoluto (siempre positivo)
    const variacionPositiva = Math.abs(variacion);
    
    return `${variacionPositiva.toFixed(2)}%`;
  };

  // Función para formatear números con 2 decimales
  const formatearNumero = (numero) => {
    return parseFloat(numero || 0).toFixed(2);
  };
  const exportarAExcel = () => {
    try {
      // Preparar los datos para exportar
      const datosParaExportar = productosFiltrados.map(producto => {
        const datosExportar = {
          'Código': producto.codigo,
          'Nombre': producto.nombre
        };
  
        const salas = ['TZ10', 'TPRR', 'TMIR', 'TXLA', 'TCSV', 'TSCR'];
        
        if (salaSeleccionada === 'TODAS') {
          // Exportar todas las salas
          salas.forEach(sala => {
            datosExportar[`${sala}_Inv_Teórico`] = producto[sala]?.inventariot || 0;
            datosExportar[`${sala}_Inv_Físico`] = producto[sala]?.inventariof || 0;
            datosExportar[`${sala}_Variación`] = calcularVariacion(producto[sala]?.inventariot || 0, producto[sala]?.inventariof || 0);
            datosExportar[`${sala}_Venta_Mes`] = producto[sala]?.venta || 0;
            datosExportar[`${sala}_Consumo_Diario`] = producto[sala]?.consumodiario || 0;
            datosExportar[`${sala}_Cobertura_Días`] = calcularCobertura(producto[sala]?.inventariof || 0, producto[sala]?.venta || 0);
          });
        } else if (salaSeleccionada === 'TOTAL') {
          // Calcular totales para el producto
          const totalProducto = {
            inventariot: 0,
            inventariof: 0,
            venta: 0,
            consumodiario: 0
          };
          
          salas.forEach(sala => {
            totalProducto.inventariot += producto[sala]?.inventariot || 0;
            totalProducto.inventariof += producto[sala]?.inventariof || 0;
            totalProducto.venta += producto[sala]?.venta || 0;
            totalProducto.consumodiario += producto[sala]?.consumodiario || 0;
          });
          
          datosExportar['Total_Inv_Teórico'] = totalProducto.inventariot;
          datosExportar['Total_Inv_Físico'] = totalProducto.inventariof;
          datosExportar['Total_Variación'] = calcularVariacion(totalProducto.inventariot, totalProducto.inventariof);
          datosExportar['Total_Venta_Mes'] = totalProducto.venta;
          datosExportar['Total_Consumo_Diario'] = totalProducto.consumodiario;
          datosExportar['Total_Cobertura_Días'] = calcularCobertura(totalProducto.inventariof, totalProducto.venta);
        } else {
          // Exportar solo la sala seleccionada
          datosExportar['Inv_Teórico'] = producto[salaSeleccionada]?.inventariot || 0;
          datosExportar['Inv_Físico'] = producto[salaSeleccionada]?.inventariof || 0;
          datosExportar['Variación'] = calcularVariacion(producto[salaSeleccionada]?.inventariot || 0, producto[salaSeleccionada]?.inventariof || 0);
          datosExportar['Venta_Mes'] = producto[salaSeleccionada]?.venta || 0;
          datosExportar['Consumo_Diario'] = producto[salaSeleccionada]?.consumodiario || 0;
          datosExportar['Cobertura_Días'] = calcularCobertura(producto[salaSeleccionada]?.inventariof || 0, producto[salaSeleccionada]?.venta || 0);
        }
  
        return datosExportar;
      });
  
      // Crear libro de trabajo
      const wb = XLSX.utils.book_new();
      
      // Crear hoja con datos
      const ws = XLSX.utils.json_to_sheet(datosParaExportar);
  
      // Definir colores para cada sala (colores tenues)
      const coloresSalas = {
        'TZ10': { 
          fondo: 'ECF0F1',  // Gris muy claro
          texto: '2C3E50'   // Azul oscuro
        },
        'TPRR': { 
          fondo: 'E8F6F3',  // Verde agua muy claro
          texto: '1A5276'   // Azul medio
        },
        'TMIR': { 
          fondo: 'FEF9E7',  // Amarillo muy claro
          texto: '7D6608'   // Amarillo oscuro
        },
        'TXLA': { 
          fondo: 'F4ECF7',  // Lila muy claro
          texto: '6C3483'   // Morado
        },
        'TCSV': { 
          fondo: 'E8F8F5',  // Verde menta muy claro
          texto: '117864'   // Verde oscuro
        },
        'TSCR': { 
          fondo: 'FDEDEC',  // Rosa muy claro
          texto: '943126'   // Rojo oscuro
        },
        'TOTAL': { 
          fondo: 'E8F5E9',  // Verde claro
          texto: '186A3B'   // Verde oscuro
        },
        'default': {
          fondo: 'F9F9F9',  // Gris claro por defecto
          texto: '000000'   // Negro
        }
      };
  
      // Definir estilos base
      const styles = {
        header: {
          fill: {
            fgColor: { rgb: "2C3E50" } // Color de fondo azul oscuro
          },
          font: {
            name: "Arial",
            sz: 12,
            bold: true,
            color: { rgb: "FFFFFF" } // Texto blanco
          },
          alignment: {
            horizontal: "center",
            vertical: "center"
          },
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } }
          }
        },
        data: {
          font: {
            name: "Arial",
            sz: 10
          },
          alignment: {
            horizontal: "center",
            vertical: "center"
          },
          border: {
            top: { style: "thin", color: { rgb: "DDDDDD" } },
            left: { style: "thin", color: { rgb: "DDDDDD" } },
            bottom: { style: "thin", color: { rgb: "DDDDDD" } },
            right: { style: "thin", color: { rgb: "DDDDDD" } }
          }
        },
        nombre: {
          font: {
            name: "Arial",
            sz: 10
          },
          alignment: {
            horizontal: "left",
            vertical: "center",
            wrapText: true
          },
          border: {
            top: { style: "thin", color: { rgb: "DDDDDD" } },
            left: { style: "thin", color: { rgb: "DDDDDD" } },
            bottom: { style: "thin", color: { rgb: "DDDDDD" } },
            right: { style: "thin", color: { rgb: "DDDDDD" } }
          }
        },
        codigo: {
          font: {
            name: "Arial",
            sz: 10,
            bold: true
          },
          fill: {
            fgColor: { rgb: "ECF0F1" } // Gris claro
          },
          alignment: {
            horizontal: "center",
            vertical: "center"
          },
          border: {
            top: { style: "thin", color: { rgb: "DDDDDD" } },
            left: { style: "thin", color: { rgb: "DDDDDD" } },
            bottom: { style: "thin", color: { rgb: "DDDDDD" } },
            right: { style: "thin", color: { rgb: "DDDDDD" } }
          }
        },
        coberturaAlta: {
          fill: {
            fgColor: { rgb: "E8F5E9" } // Verde claro
          },
          font: {
            name: "Arial",
            sz: 10,
            color: { rgb: "27AE60" }, // Verde
            bold: true
          }
        },
        coberturaMedia: {
          fill: {
            fgColor: { rgb: "FEF9E7" } // Amarillo claro
          },
          font: {
            name: "Arial",
            sz: 10,
            color: { rgb: "F39C12" }, // Naranja
            bold: true
          }
        },
        coberturaBaja: {
          fill: {
            fgColor: { rgb: "FDEDEC" } // Rojo claro
          },
          font: {
            name: "Arial",
            sz: 10,
            color: { rgb: "E74C3C" }, // Rojo
            bold: true
          }
        },
        variacion: {
          font: {
            name: "Arial",
            sz: 10,
            color: { rgb: "1976D2" }, // Azul
            bold: true
          }
        },
        numero: {
          numFmt: "0.00" // Formato de 2 decimales
        }
      };
  
      // Función para determinar a qué sala pertenece una columna
      const obtenerSalaDeColumna = (nombreColumna) => {
        const salas = ['TZ10', 'TPRR', 'TMIR', 'TXLA', 'TCSV', 'TSCR', 'TOTAL'];
        for (let sala of salas) {
          if (nombreColumna.includes(sala) || nombreColumna === 'Variación' || 
              nombreColumna === 'Inv_Teórico' || nombreColumna === 'Inv_Físico' ||
              nombreColumna === 'Venta_Mes' || nombreColumna === 'Consumo_Diario' || 
              nombreColumna === 'Cobertura_Días') {
            return salaSeleccionada !== 'TODAS' ? salaSeleccionada : sala;
          }
        }
        return 'default';
      };
  
      // Aplicar estilos a los encabezados
      const range = XLSX.utils.decode_range(ws['!ref']);
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const headerCell = XLSX.utils.encode_cell({ r: range.s.r, c: C });
        if (!ws[headerCell]) continue;
        ws[headerCell].s = styles.header;
      }
  
      // Aplicar estilos a los datos
      for (let R = range.s.r + 1; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellAddress]) continue;
          
          const header = XLSX.utils.encode_cell({ r: range.s.r, c: C });
          const headerText = ws[header] ? ws[header].v : '';
          const cellValue = ws[cellAddress].v;
          
          // Determinar la sala de esta columna
          const sala = obtenerSalaDeColumna(headerText);
          const colorSala = coloresSalas[sala] || coloresSalas.default;
          
          // Estilo base para datos
          let cellStyle = { ...styles.data };
          
          // Aplicar color de fondo según la sala
          cellStyle.fill = {
            fgColor: { rgb: colorSala.fondo }
          };
          
          // Aplicar color de texto según la sala
          cellStyle.font = {
            ...cellStyle.font,
            color: { rgb: colorSala.texto }
          };
  
          // Estilo especial para columna "Código"
          if (headerText === 'Código') {
            cellStyle = { ...cellStyle, ...styles.codigo };
          }
          
          // Estilo especial para columna "Nombre"
          if (headerText === 'Nombre') {
            cellStyle = { ...cellStyle, ...styles.nombre };
            // Para nombre, no aplicamos colores de sala
            cellStyle.fill = { fgColor: { rgb: "FFFFFF" } };
            cellStyle.font = { ...cellStyle.font, color: { rgb: "000000" } };
          }
          
          // Estilo para columnas numéricas
          if (typeof cellValue === 'number' && !headerText.includes('Variación')) {
            cellStyle = { ...cellStyle, ...styles.numero };
          }
          
          // Estilo para variación (color azul como en la web)
          if (headerText.includes('Variación')) {
            cellStyle = { ...cellStyle, ...styles.variacion };
            // Mantener el color de fondo de la sala pero texto azul
            cellStyle.fill = { fgColor: { rgb: colorSala.fondo } };
            cellStyle.font = { 
              ...cellStyle.font, 
              color: { rgb: "1976D2" },
              bold: true
            };
          }
          
          // Estilo para cobertura (colorear según el valor)
          if (headerText.includes('Cobertura') && typeof cellValue === 'number') {
            let estiloCobertura;
            if (cellValue > 20) {
              estiloCobertura = styles.coberturaAlta;
            } else if (cellValue > 10) {
              estiloCobertura = styles.coberturaMedia;
            } else {
              estiloCobertura = styles.coberturaBaja;
            }
            
            cellStyle = { 
              ...cellStyle, 
              ...estiloCobertura,
              fill: { fgColor: { rgb: estiloCobertura.fill.fgColor } }
            };
          }
          
          ws[cellAddress].s = cellStyle;
        }
      }
  
      // Ajustar el ancho de las columnas
      const colWidths = [];
      Object.keys(datosParaExportar[0] || {}).forEach(key => {
        console.log("KEY", key);
        if (key === "Nombre") { 
          colWidths.push({ wch: Math.max(key.length, 70) });
        } else if (key === "Código") {
          colWidths.push({ wch: Math.max(key.length, 15) });
        } else if (key.includes('Variación')) {
          colWidths.push({ wch: Math.max(key.length, 15) });
        } else {
          colWidths.push({ wch: Math.max(key.length, 12) });
        }
      });
      ws['!cols'] = colWidths;
  
      // Congelar paneles (fijar primera fila y primeras 2 columnas)
      ws['!freeze'] = { x: 2, y: 1 };
  
      // Agregar filtros automáticos
      ws['!autofilter'] = { ref: XLSX.utils.encode_range(range) };
  
      // Agregar la hoja al libro
      XLSX.utils.book_append_sheet(wb, ws, 'Inventario_Salas');
  
      // Generar nombre del archivo con fecha y sala seleccionada
      const fecha = new Date().toISOString().split('T')[0];
      const nombreArchivo = `Inventario_Salas_${salaSeleccionada}_${fecha}.xlsx`;
  
      // Descargar el archivo
      XLSX.writeFile(wb, nombreArchivo);
  
      alert(`Archivo "${nombreArchivo}" descargado exitosamente!`);
    } catch (error) {
      console.error('Error al exportar a Excel:', error);
      alert('Error al exportar los datos a Excel');
    }
  };
  // Filtrar productos
  const productosFiltrados = useMemo(() => {
    return productos.filter(producto =>
      producto.codigo.toLowerCase().includes(filtro.toLowerCase()) ||
      producto.nombre.toLowerCase().includes(filtro.toLowerCase())
    );
  }, [productos, filtro]);

  const salas = ['TZ10', 'TPRR', 'TMIR', 'TXLA', 'TCSV', 'TSCR'];

  // Determinar qué columnas mostrar según la selección
  const mostrarSoloTotales = salaSeleccionada === 'TOTAL';
  const mostrarSalaEspecifica = salas.includes(salaSeleccionada);
  const mostrarTodasLasSalas = salaSeleccionada === 'TODAS';

  if (cargando) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h2>Cargando datos...</h2>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', maxWidth: '100%', overflow: 'hidden' }}>
      <h1 style={{ textAlign: 'center', color: '#2c3e50', marginBottom: '30px', fontSize: '28px' }}>
        Inventario de Salas de Ventas
      </h1>
      
      {/* Filtros */}
      <div style={{ display: 'flex', gap: '20px', marginBottom: '20px', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
        <input
          type="text"
          placeholder="Buscar por código o nombre..."
          value={filtro}
          onChange={(e) => setFiltro(e.target.value)}
          style={{ padding: '12px', border: '2px solid #3498db', borderRadius: '5px', width: '300px', fontSize: '16px' }}
        />
        
        <select
          value={salaSeleccionada}
          onChange={(e) => setSalaSeleccionada(e.target.value)}
          style={{ padding: '12px', border: '2px solid #3498db', borderRadius: '5px', fontSize: '16px', backgroundColor: 'white' }}
        >
          <option value="TODAS">Todas las salas</option>
          <option value="TOTAL">Total</option>
          {salas.map(sala => (
            <option key={sala} value={sala}>{sala}</option>
          ))}
        </select>

        
        {/* Botón adicional para recargar datos */}
        <button
          onClick={handleRecargarDatos}
          style={{
            padding: '14px 28px',
            backgroundColor: productosFiltrados.length === 0 ? '#e0e0e0' : 'transparent',
            color: productosFiltrados.length === 0 ? '#9e9e9e' : '#2196f3',
            border: productosFiltrados.length === 0 ? '2px solid #e0e0e0' : '2px solid #2196f3',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: productosFiltrados.length === 0 ? 'not-allowed' : 'pointer',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            minWidth: '160px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            backdropFilter: productosFiltrados.length === 0 ? 'none' : 'blur(10px)',
            boxShadow: productosFiltrados.length === 0 ? 'none' : '0 4px 20px rgba(33, 150, 243, 0.2)',
            position: 'relative',
            overflow: 'hidden',
            letterSpacing: '0.5px',
            textTransform: 'uppercase'
          }}
          onMouseOver={(e) => {
            if (productosFiltrados.length > 0) {
              e.target.style.backgroundColor = 'rgba(33, 150, 243, 0.1)';
              e.target.style.boxShadow = '0 6px 25px rgba(33, 150, 243, 0.3)';
              e.target.style.transform = 'translateY(-2px)';
            }
          }}
          onMouseOut={(e) => {
            if (productosFiltrados.length > 0) {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.boxShadow = '0 4px 20px rgba(33, 150, 243, 0.2)';
              e.target.style.transform = 'translateY(0)';
            }
          }}
          onMouseDown={(e) => {
            if (productosFiltrados.length > 0) {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 2px 10px rgba(33, 150, 243, 0.4)';
            }
          }}
          onMouseUp={(e) => {
            if (productosFiltrados.length > 0) {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 25px rgba(33, 150, 243, 0.3)';
            }
          }}
          title={'Actualizar todos los datos '}
        >
          🚀 Actualizar
        </button>

        {/* Botón para exportar a Excel */}
        <button
  onClick={exportarAExcel}
  disabled={productosFiltrados.length === 0}
  style={{
    padding: '14px 28px',
    backgroundColor: productosFiltrados.length === 0 ? '#e0e0e0' : 'transparent',
    color: productosFiltrados.length === 0 ? '#9e9e9e' : '#2196f3',
    border: productosFiltrados.length === 0 ? '2px solid #e0e0e0' : '2px solid #2196f3',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: productosFiltrados.length === 0 ? 'not-allowed' : 'pointer',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    minWidth: '160px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    backdropFilter: productosFiltrados.length === 0 ? 'none' : 'blur(10px)',
    boxShadow: productosFiltrados.length === 0 ? 'none' : '0 4px 20px rgba(33, 150, 243, 0.2)',
    position: 'relative',
    overflow: 'hidden',
    letterSpacing: '0.5px',
    textTransform: 'uppercase'
  }}
  onMouseOver={(e) => {
    if (productosFiltrados.length > 0) {
      e.target.style.backgroundColor = 'rgba(33, 150, 243, 0.1)';
      e.target.style.boxShadow = '0 6px 25px rgba(33, 150, 243, 0.3)';
      e.target.style.transform = 'translateY(-2px)';
    }
  }}
  onMouseOut={(e) => {
    if (productosFiltrados.length > 0) {
      e.target.style.backgroundColor = 'transparent';
      e.target.style.boxShadow = '0 4px 20px rgba(33, 150, 243, 0.2)';
      e.target.style.transform = 'translateY(0)';
    }
  }}
  onMouseDown={(e) => {
    if (productosFiltrados.length > 0) {
      e.target.style.transform = 'translateY(0)';
      e.target.style.boxShadow = '0 2px 10px rgba(33, 150, 243, 0.4)';
    }
  }}
  onMouseUp={(e) => {
    if (productosFiltrados.length > 0) {
      e.target.style.transform = 'translateY(-2px)';
      e.target.style.boxShadow = '0 6px 25px rgba(33, 150, 243, 0.3)';
    }
  }}
  title={productosFiltrados.length === 0 ? 'No hay datos para exportar' : `Exportar ${productosFiltrados.length} registros a Excel`}
>
  <span style={{ 
    fontSize: '18px',
    filter: productosFiltrados.length === 0 ? 'grayscale(100%)' : 'none'
  }}>
    ⚡
  </span>
  Exportar Excel
</button>
      </div>

      {/* Tabla completa sin columnas fijas */}
      <div style={{ overflowX: 'auto', marginBottom: '20px' }}>
        <table style={{ borderCollapse: 'collapse', width: '100%' }}>
          <thead>
            <tr>
              {/* Columnas de código y nombre */}
              <th style={{ 
                padding: '15px', 
                border: '1px solid #ddd', 
                textAlign: 'center', 
                backgroundColor: '#2c3e50', 
                color: 'white',
                minWidth: '100px'
              }}>
                Código
              </th>
              <th style={{ 
                padding: '15px', 
                border: '1px solid #ddd', 
                textAlign: 'center', 
                backgroundColor: '#2c3e50', 
                color: 'white',
                minWidth: '200px'
              }}>
                Nombre
              </th>

              {/* Columnas de salas - Solo si estamos en modo TODAS */}
              {mostrarTodasLasSalas && salas.map(sala => (
                <th key={sala} style={{ padding: '15px', border: '1px solid #ddd', textAlign: 'center', backgroundColor: '#2c3e50', color: 'white', minWidth: '180px' }} colSpan="6">
                  {sala}
                </th>
              ))}
              
              {/* Columna de sala específica - Solo si se seleccionó una sala específica */}
              {mostrarSalaEspecifica && (
                <th style={{ padding: '15px', border: '1px solid #ddd', textAlign: 'center', backgroundColor: '#2c3e50', color: 'white', minWidth: '180px' }} colSpan="6">
                  {salaSeleccionada}
                </th>
              )}
              
              {/* Columna de totales generales - Solo si se seleccionó TOTAL */}
              {mostrarSoloTotales && (
                <th style={{ padding: '15px', border: '1px solid #ddd', textAlign: 'center', backgroundColor: '#2c3e50', color: 'white', minWidth: '180px' }} colSpan="6">
                  TOTAL
                </th>
              )}
            </tr>
            
            {/* Segunda fila de encabezados */}
            <tr>
              {/* Espacios para código y nombre */}
              <th style={{ padding: '15px', border: '1px solid #ddd', textAlign: 'center', backgroundColor: '#2c3e50', color: 'white' }}></th>
              <th style={{ padding: '15px', border: '1px solid #ddd', textAlign: 'center', backgroundColor: '#2c3e50', color: 'white' }}></th>

              {/* Encabezados para todas las salas */}
              {mostrarTodasLasSalas && salas.map(sala => (
                <React.Fragment key={sala}>
                  <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', backgroundColor: '#34495e', color: 'white', fontSize: '12px' }}>Inv. Teórico</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', backgroundColor: '#34495e', color: 'white', fontSize: '12px' }}>Inv. Físico</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', backgroundColor: '#34495e', color: 'white', fontSize: '12px' }}>Variación</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', backgroundColor: '#34495e', color: 'white', fontSize: '12px' }}>Venta Mes</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', backgroundColor: '#34495e', color: 'white', fontSize: '12px' }}>Consumo Diario</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', backgroundColor: '#34495e', color: 'white', fontSize: '12px' }}>Cobertura <br />(días)</th>
                </React.Fragment>
              ))}
              
              {/* Encabezados para sala específica */}
              {mostrarSalaEspecifica && (
                <React.Fragment>
                  <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', backgroundColor: '#34495e', color: 'white', fontSize: '12px' }}>Inv. Teórico</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', backgroundColor: '#34495e', color: 'white', fontSize: '12px' }}>Inv. Físico</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', backgroundColor: '#34495e', color: 'white', fontSize: '12px' }}>Variación</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', backgroundColor: '#34495e', color: 'white', fontSize: '12px' }}>Venta Mes</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', backgroundColor: '#34495e', color: 'white', fontSize: '12px' }}>Consumo Diario</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', backgroundColor: '#34495e', color: 'white', fontSize: '12px' }}>Cobertura <br />(días)</th>
                </React.Fragment>
              )}
              
              {/* Encabezados para totales generales */}
              {mostrarSoloTotales && (
                <React.Fragment>
                  <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', backgroundColor: '#34495e', color: 'white', fontSize: '12px' }}>Inv. Teórico</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', backgroundColor: '#34495e', color: 'white', fontSize: '12px' }}>Inv. Físico</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', backgroundColor: '#34495e', color: 'white', fontSize: '12px' }}>Variación</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', backgroundColor: '#34495e', color: 'white', fontSize: '12px' }}>Venta Mes</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', backgroundColor: '#34495e', color: 'white', fontSize: '12px' }}>Consumo Diario</th>
                  <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', backgroundColor: '#34495e', color: 'white', fontSize: '12px' }}>Cobertura <br />(días)</th>
                </React.Fragment>
              )}
            </tr>
          </thead>
          <tbody>
            {productosFiltrados.map(producto => {
              // Calcular totales para cada producto
              const totalProducto = {
                inventariot: 0,
                inventariof: 0,
                venta: 0,
                consumodiario: 0,
                cobertura: 0
              };
              
              salas.forEach(sala => {
                totalProducto.inventariot += producto[sala]?.inventariot || 0;
                totalProducto.inventariof += producto[sala]?.inventariof || 0;
                totalProducto.venta += producto[sala]?.venta || 0;
                totalProducto.consumodiario += producto[sala]?.consumodiario || 0;
              });
              
              totalProducto.cobertura = calcularCobertura(totalProducto.inventariof, totalProducto.venta);
              
              return (
                <tr key={producto.codigo}>
                  {/* Columnas de código y nombre */}
                  <td style={{ 
                    padding: '12px', 
                    border: '1px solid #ddd', 
                    fontWeight: 'bold', 
                    backgroundColor: '#ecf0f1',
                    textAlign: 'center'
                  }}>{producto.codigo}</td>
                  <td style={{ 
                    padding: '12px', 
                    border: '1px solid #ddd', 
                    textAlign: 'left', 
                    backgroundColor: 'white',
                    fontSize: '12px',
                    lineHeight: '1.2',
                    maxWidth: '200px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }} title={producto.nombre}>
                    {producto.nombre}
                  </td>

                  {/* Mostrar todas las salas */}
                  {mostrarTodasLasSalas && salas.map(sala => (
                    <React.Fragment key={sala}>
                      <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', fontFamily: 'Courier New, monospace', fontWeight: 'bold', backgroundColor: '#f9f9f9' }}>
                        {formatearNumero(producto[sala]?.inventariot)}
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', fontFamily: 'Courier New, monospace', fontWeight: 'bold', backgroundColor: '#e3f2fd' }}>
                        <span 
                          style={{ cursor: 'pointer' }}
                          title={producto[sala]?.fecha ? `Fecha: ${producto[sala].fecha}` : 'Sin fecha'}
                        >
                          {formatearNumero(producto[sala]?.inventariof)}
                        </span>
                      </td>
                      <td style={{ 
                        padding: '10px', 
                        border: '1px solid #ddd', 
                        textAlign: 'center', 
                        fontWeight: 'bold',
                        color: '#1976d2',
                        backgroundColor: '#e3f2fd'
                      }}>
                        {calcularVariacion(producto[sala]?.inventariot || 0, producto[sala]?.inventariof || 0)}
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', fontFamily: 'Courier New, monospace', backgroundColor: '#f9f9f9' }}>
                        {formatearNumero(producto[sala]?.venta)}
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', fontFamily: 'Courier New, monospace', backgroundColor: '#f9f9f9' }}>
                        {formatearNumero(producto[sala]?.consumodiario)}
                      </td>
                      <td style={{ 
                        padding: '10px', 
                        border: '1px solid #ddd', 
                        textAlign: 'center', 
                        fontWeight: 'bold',
                        color: calcularCobertura(producto[sala]?.inventariof || 0, producto[sala]?.venta || 0) > 20 ? '#27ae60' : 
                              calcularCobertura(producto[sala]?.inventariof || 0, producto[sala]?.venta || 0) > 10 ? '#f39c12' : '#e74c3c',
                        backgroundColor: calcularCobertura(producto[sala]?.inventariof || 0, producto[sala]?.venta || 0) > 20 ? '#eafaf1' : 
                                        calcularCobertura(producto[sala]?.inventariof || 0, producto[sala]?.venta || 0) > 10 ? '#fef9e7' : '#fdedec'
                      }}>
                        {calcularCobertura(producto[sala]?.inventariof || 0, producto[sala]?.venta || 0)}
                      </td>
                    </React.Fragment>
                  ))}
                  
                  {/* Mostrar sala específica (solo la sala, sin totales) */}
                  {mostrarSalaEspecifica && (
                    <React.Fragment>
                      <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', fontFamily: 'Courier New, monospace', fontWeight: 'bold', backgroundColor: '#f9f9f9' }}>
                        {formatearNumero(producto[salaSeleccionada]?.inventariot)}
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', fontFamily: 'Courier New, monospace', fontWeight: 'bold', backgroundColor: '#e3f2fd' }}>
                        <span 
                          style={{ cursor: 'pointer' }}
                          title={producto[salaSeleccionada]?.fecha ? `Fecha: ${producto[salaSeleccionada].fecha}` : 'Sin fecha'}
                        >
                          {formatearNumero(producto[salaSeleccionada]?.inventariof)}
                        </span>
                      </td>
                      <td style={{ 
                        padding: '10px', 
                        border: '1px solid #ddd', 
                        textAlign: 'center', 
                        fontWeight: 'bold',
                        color: '#1976d2',
                        backgroundColor: '#e3f2fd'
                      }}>
                        {calcularVariacion(producto[salaSeleccionada]?.inventariot || 0, producto[salaSeleccionada]?.inventariof || 0)}
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', fontFamily: 'Courier New, monospace', backgroundColor: '#f9f9f9' }}>
                        {formatearNumero(producto[salaSeleccionada]?.venta)}
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', fontFamily: 'Courier New, monospace', backgroundColor: '#f9f9f9' }}>
                        {formatearNumero(producto[salaSeleccionada]?.consumodiario)}
                      </td>
                      <td style={{ 
                        padding: '10px', 
                        border: '1px solid #ddd', 
                        textAlign: 'center', 
                        fontWeight: 'bold',
                        color: calcularCobertura(producto[salaSeleccionada]?.inventariof || 0, producto[salaSeleccionada]?.venta || 0) > 20 ? '#27ae60' : 
                              calcularCobertura(producto[salaSeleccionada]?.inventariof || 0, producto[salaSeleccionada]?.venta || 0) > 10 ? '#f39c12' : '#e74c3c',
                        backgroundColor: calcularCobertura(producto[salaSeleccionada]?.inventariof || 0, producto[salaSeleccionada]?.venta || 0) > 20 ? '#eafaf1' : 
                                        calcularCobertura(producto[salaSeleccionada]?.inventariof || 0, producto[salaSeleccionada]?.venta || 0) > 10 ? '#fef9e7' : '#fdedec'
                      }}>
                        {calcularCobertura(producto[salaSeleccionada]?.inventariof || 0, producto[salaSeleccionada]?.venta || 0)}
                      </td>
                    </React.Fragment>
                  )}
                  
                  {/* Totales por producto - Solo mostrar si se seleccionó TOTAL */}
                  {mostrarSoloTotales && (
                    <React.Fragment>
                      <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', fontFamily: 'Courier New, monospace', fontWeight: 'bold', backgroundColor: '#e8f5e9' }}>
                        {formatearNumero(totalProducto.inventariot)}
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', fontFamily: 'Courier New, monospace', fontWeight: 'bold', backgroundColor: '#e8f5e9' }}>
                        {formatearNumero(totalProducto.inventariof)}
                      </td>
                      <td style={{ 
                        padding: '10px', 
                        border: '1px solid #ddd', 
                        textAlign: 'center', 
                        fontWeight: 'bold',
                        color: '#1976d2',
                        backgroundColor: '#e3f2fd'
                      }}>
                        {calcularVariacion(totalProducto.inventariot, totalProducto.inventariof)}
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', fontFamily: 'Courier New, monospace', backgroundColor: '#e8f5e9' }}>
                        {formatearNumero(totalProducto.venta)}
                      </td>
                      <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center', fontFamily: 'Courier New, monospace', backgroundColor: '#e8f5e9' }}>
                        {formatearNumero(totalProducto.consumodiario)}
                      </td>
                      <td style={{ 
                        padding: '10px', 
                        border: '1px solid #ddd', 
                        textAlign: 'center', 
                        fontWeight: 'bold',
                        color: totalProducto.cobertura > 20 ? '#27ae60' : 
                              totalProducto.cobertura > 10 ? '#f39c12' : '#e74c3c',
                        backgroundColor: totalProducto.cobertura > 20 ? '#eafaf1' : 
                                        totalProducto.cobertura > 10 ? '#fef9e7' : '#fdedec'
                      }}>
                        {totalProducto.cobertura}
                      </td>
                    </React.Fragment>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div style={{ textAlign: 'center', color: '#7f8c8d', fontStyle: 'italic', marginTop: '20px' }}>
        <p>Mostrando {productosFiltrados.length} de {productos.length} productos</p>
        <p style={{ fontSize: '14px', marginTop: '5px' }}>Cobertura (días) = Inventario Físico / (Venta Mensual / 30)</p>
        <p style={{ fontSize: '12px', marginTop: '5px' }}>Pase el mouse sobre el inventario físico para ver la fecha</p>
        <p style={{ fontSize: '12px', marginTop: '5px' }}>Pase el mouse sobre el nombre para ver el texto completo</p>
      </div>
    </div>
  );
};

export default CoberturaInventarioSV;